/**
 * Dependencies.
 */
import { Component, Mixins } from 'vue-property-decorator';

import applicationConstant from '@/modules/main/constants/application.constant';
import TimelineMixin from '@/modules/tracking/mixins/timeline.mixin';
import TrackingMixin from '@/modules/tracking/mixins/tracking.mixin';
import Error from '@/ui/components/error.component.vue';
import Loader from '@/ui/components/loader.component.vue';
import Timeline from '@/ui/components/timeline/timeline.component.vue';

/**
 * Component.
 */
@Component({
  components: { Error, Loader, Timeline },
  name: 'out-of-range-scene'
})
export default class extends Mixins(TrackingMixin, TimelineMixin) {
  /**
   * Getter status title.
   */
  get statusTitle() {
    return this.i18n('TRACKING.SENTENCES.STATUS_HELLO', false, 'upperFirst', {
      name: this.client || '-'
    });
  }

  /**
   * Getter status sentence.
   */
  get statusSentence() {
    const { address } = this.order || {};
    const { countryCode = '' } = address || {};
    const { lang: { currentLanguage: { code: languageCode = '' } = {} } = {} } =
      this.$kit || {};

    let { supportUrl = '' } = applicationConstant || {};

    supportUrl = supportUrl
      .replace('{store}', countryCode.toLocaleLowerCase())
      .replace('{language}', languageCode.toLocaleLowerCase());

    const support = `<a href="${supportUrl}" class="status-success__support" target="_blank">${this.i18n(
      'TRACKING.MESSAGES.CUSTOMER_SUPPORT'
    )}</a>`;

    return this.i18n('TRACKING.SENTENCES.OUT_OF_RANGE', false, 'plain', {
      support: support.toLowerCase()
    });
  }

  /**
   * Lifecycle mounted hook.
   */
  async mounted() {
    this.$on('trackingDataUpdated', () => {
      const isValid = this.handleIsValidToBeOnScene();

      if (!isValid) {
        this.handleForceTrackingScene();
      }
    });

    await this.handleInitializeMixin();

    const isValid = this.handleIsValidToBeOnScene();

    if (!isValid) {
      this.handleForceTrackingScene();
    }
  }

  /**
   * Handle is valid to be on scene.
   */
  handleIsValidToBeOnScene() {
    return this.canCreateChangeRequest;
  }

  /**
   * Handle change address.
   */
  handleChangeAddress() {
    this.$router.push({
      name: 'SearchAddress',
      params: {
        key: this.key
      }
    });
  }

  /**
   * Handle cancel.
   */
  handleCancel() {
    this.$router.push({
      name: 'Tracking',
      params: {
        key: this.key
      }
    });
  }
}
